import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { QueryLoadingState } from '@globalconnect/query';
import { Observable } from 'rxjs';
import { InstallationReportingV2Service } from '../../../../installation-reporting-app/service/sdu/installation-reporting-v2.service';
import {
  InstallationReportOrderDetail,
  InstallationReportResponseV2,
} from '../../../../shared/installation-report-content-v2/installation-report-content-entities';
import { isTopLevelDomainFI } from '../../../../shared/util/deploy-helper';
import { ReportModalService } from '../../report-modal.service';
import { OrdersOverviewResponse } from '../orders-overview-entities';
import { finlandColumns, swedenColumns } from './orders-overview-columns';

@Component({
  selector: 'app-orders-overview-table',
  templateUrl: './orders-overview-table.component.html',
  styleUrls: ['./orders-overview-table.component.scss'],
  standalone: false,
})
export class OrdersOverviewTableComponent implements OnInit {
  private readonly installationReportingServiceV2 = inject(
    InstallationReportingV2Service,
  );
  private readonly reportModalService = inject(ReportModalService);

  @Input() ifsNumber: string;
  @Input() filterText: string;
  @Input() isLoading: boolean;
  @Input() filterFields: string[];
  @Input() set installationReports(
    installationReports: InstallationReportOrderDetail[],
  ) {
    this._installationReports = installationReports.filter(
      (installationReport) => installationReport.deliveryOrderId !== null,
    );
  }

  get installationReports() {
    return this._installationReports ?? [];
  }

  @Output() closeOrdersOverviewModal = new EventEmitter();

  isDeliveryPortalFI: boolean = isTopLevelDomainFI();
  currentDomainColumns = this.isDeliveryPortalFI
    ? finlandColumns
    : swedenColumns;
  private _installationReports: InstallationReportOrderDetail[];

  savedInstallationReportsResponse$: Observable<
    QueryLoadingState<InstallationReportResponseV2[]>
  >;

  ngOnInit() {
    this.savedInstallationReportsResponse$ =
      this.installationReportingServiceV2.getAllInstallationReportsForProject$(
        this.ifsNumber,
      );
  }

  openInstallationReportModal(order: OrdersOverviewResponse) {
    const address = `${order.locationInformation.streetName} ${order.locationInformation.postalCode} ${order.locationInformation.city}`;
    this.closeOrdersOverviewModal.emit();
    this.reportModalService.setModalState({
      ['installationReportModalV2']: {
        open: true,
        data: {
          sourceKey: order.deliveryOrderId ?? '',
          leadId: order.deliveryOrderId ?? '',
          name: address,
          id: order.id,
        },
      },
    });
  }
}
